import { render } from "./ProductPage.vue?vue&type=template&id=31b2a988&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=31b2a988&lang=scss&scoped=true"
import "./ProductPage.vue?vue&type=style&index=1&id=31b2a988&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b2a988"]])

export default __exports__